import $ from '@js/modules/selector';

import {showSignupModal} from '@js/actions/userActions';
import {addToBasket} from '@js/actions/basketActions';

import {userStore} from '@js/stores/userStore';
import {basketStore} from '@js/stores/basketStore';

import {videoLazyLoader} from '@js/modules/videoLazyLoader';

import {checkoutPath} from '@js/constants/routesHelper';

import AnalyticsService from '@js/modules/analyticsService';


class ProductManager {
    _basketButtonIds = [
        '#add-basket-main',
        '#add-basket-bottom'
    ];

    _basketErrorId = '#basket-error';

    _basketErrorContentId = '#basket-error-content';

    /* Public methods
    ******************** */
    initialize = () => {
        videoLazyLoader();

        this._handleAddToBasketClick();
    };

    /* Private methods
    ******************** */
    _enableBasketButtons = () => {
        this._basketButtonIds.forEach((buttonId) => {
            const $addBasketButton = $(buttonId);
            const $addBasketLoader = $(buttonId + '-loader');

            if ($addBasketButton) {
                $addBasketButton.removeAttr('disabled');
            }

            if ($addBasketLoader) {
                $addBasketLoader.addClass('hidden');
                $addBasketLoader.removeClass('inline');
            }
        });
    };

    _disableBasketButtons = () => {
        this._basketButtonIds.forEach((buttonId) => {
            const $addBasketButton = $(buttonId);
            const $addBasketLoader = $(buttonId + '-loader');

            if ($addBasketButton) {
                $addBasketButton.attr('disabled', 'disabled');
            }

            if ($addBasketLoader) {
                $addBasketLoader.removeClass('hidden');
                $addBasketLoader.addClass('inline');
            }
        });
    };

    _addToBasket = (productId) => {
        addToBasket(productId, 'product_page')
            .then((response) => {
                const $basketError = $(this._basketErrorId);

                if (response.errors) {
                    const $basketErrorContent = $(this._basketErrorContentId);

                    if ($basketError) {
                        $basketError.removeClass('hidden');
                        $basketErrorContent.html(response.errors.join(', '));
                    }

                    this._enableBasketButtons();

                    return;
                } else if ($basketError) {
                    $basketError.addClass('hidden');
                }

                const basket = response.basket;
                const product = basket?.products?.first();

                basketStore.basket = basket;

                setTimeout(() => this._enableBasketButtons(), 500);

                AnalyticsService.trackAddToBasket(product.slug, product.name, basket.totalAmount)
                    .then(() => {
                        if (userStore.isConnected) {
                            window.location = checkoutPath();
                        } else {
                            userStore.redirectionURL = checkoutPath();

                            showSignupModal();
                        }
                    });
            });
    };

    _handleAddToBasketClick = () => {
        this._basketButtonIds.forEach((buttonId) => {
            const $addBasketButton = $(buttonId);
            if (!$addBasketButton) {
                return;
            }

            $addBasketButton.on('click', (event) => {
                event.preventDefault();

                this._disableBasketButtons();

                const productId = $addBasketButton.data('product-id');

                this._addToBasket(productId);
            });
        });
    };
}

export default new ProductManager();
